module.exports = __webpack_public_path__ + "static/img/user-comment7.0f817e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment7.png
// module id = 53zG
// module chunks = 0